import React from 'react';

// Receiver helpers
import { Asset } from '@cube3/common/model/schema/resources/asset';

// import MetadataFormRenderer from '../MetaData/MetadataForm';

// UI

import { useResourceList__ALPHA } from '@cube3/state/src/redux/components/Hooks/useResourceList';
import { ActivityGroup } from '../../../ActvityFeeds/prefabs/ActivityGroup';
import { LoadMoreBumper } from '@cube3/ui/src/utils/withLazyLoad';
import { Scrollbar } from '@cube3/cubicle/src/core/atoms/Scrollbar';
import { EmptyNotificationItem } from '@cube3/cubicle/src/core/atoms/Activity/EmptyNotificationItem';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';
import { SizeVariants } from '@cube3/cubicle/src/theme/themes';
import { VBox } from '@cube3/cubicle/src/core/templates/layout/Flex';
import { isMobile } from 'react-device-detect';

/// @ Author : Simon @AmbassadorsLab (original metadata component made by michiel)
/// <Summary>
/// Detailview tab for metadata information about asset in
/// </Summary>

interface Properties {
  asset: Asset;
}

const loaders = [1, 2, 3];

const params = {
  included: 'subject,related_resources',
  page: { size: 20 }
};
export const DetailViewFeed: React.FC<Properties> = (props) => {
  const { asset } = props;

  return <TestActivities asset={asset} />;
};
const noop = () => {};
const TestActivities = ({ asset }) => {
  const [pages, setPages] = React.useState([1]);

  const loadMore = React.useCallback(() => {
    setPages([...pages, pages.length + 1]);
  }, [pages, setPages]);

  const activities = useResourceList__ALPHA({
    resourceType: 'asset',
    resourceId: asset?.id,
    edgeType: 'activity',
    edgeLabel: 'activities',
    strategy: 'fetch-on-mount',
    params: params
  });

  const showLoadMore =
    !activities.loading &&
    activities.pageCounts &&
    pages.length < activities.pageCounts.pageCount;

  return (
    <Scrollbar autoHeight={true} autoHeightMax={isMobile ? 400 : 900}>
      <section
        style={{
          padding: isMobile ? '12px 8px' : 24,
          width: isMobile ? 'calc(100vw - 70px)' : ''
        }}
      >
        {!activities.loading && !activities.resources.length ? (
          <VBox gap={8}>
            {loaders.map((l) => (
              <EmptyNotificationItem
                key={l}
                focusedState={l === 1}
                variant="determinate"
                animationVariant="fillIn"
              />
            ))}

            <Typography
              colorVariant="02"
              lineHeight="loose"
              variant={SizeVariants.md}
            >
              No activity yet
            </Typography>
          </VBox>
        ) : null}
        <VBox gap={8}>
          {activities.resources?.length ? (
            <ActivityGroup
              activities={activities.resources}
              onClickLink={noop}
              variant="asset"
            />
          ) : null}
        </VBox>
        {/* <pre>{JSON.stringify(activities.resources, null, 2)}</pre> */}
        {showLoadMore && (
          <LoadMoreBumper
            once={false}
            callback={(visible) => (visible ? loadMore() : undefined)}
          />
        )}
      </section>
    </Scrollbar>
  );
};
